export function getHeader(headerData: any, changeYear: boolean,activeTab:string) {
  const headerArray = [];
  headerArray.push({
    label: activeTab ==="expenses" ? "Expense":"Sales",
    value:activeTab ==="expenses" ? "Expense":"Sales",
    defaultChecked: true,
    checked: true,
  });
  headerArray.push({
    label: "Trend",
    value: "Trend",
    defaultChecked: true,
    checked: true,
  });

  changeYear &&
    headerData?.current_year_monthly_data?.map((dataItem: any) => {
      headerArray.push({
        label: `${
          dataItem?.month[0]?.toUpperCase() + dataItem?.month?.slice(1)
        } ${dataItem?.year}`,
        value: `${dataItem?.month}`,
        defaultChecked: true,
        checked: true,
      });
    });

  changeYear === false &&
    headerData?.prev_year_monthly_data?.map((dataItem: any) => {
      headerArray.push({
        label: `${
          dataItem?.month[0]?.toUpperCase() + dataItem?.month?.slice(1)
        } ${dataItem?.year}`,
        value: `${dataItem?.month}`,
        defaultChecked: true,
        checked: true,
      });
    });

  headerArray.push({
    label: "Yearly",
    value: "yearly",
    defaultChecked: true,
    checked: true,
  });
  headerArray.push({
    label: "Year %",
    value: "year_percentage",
    defaultChecked: true,
    checked: true,
  });

  return headerArray;
}
